import s from './LocationList.module.scss';
import LocationCard from '../../../components/LocationCard/LocationCard';
import {useEffect, useState} from "react";
import api from "../../../api/client";
import LoadingInside from "../../../components/Loading/LoadingInside";

const LocationList = () => {
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await api.get(

                    `/api/locations`
                );

                setLocations(response.data || []);

            } catch (err) {
                console.error("Failed to load locations", err);
                setError(true)
            } finally {
                setLoading(false);
            }
        };

        fetchLocations();
    }, []);

    if (loading) {
        return (
            <LoadingInside height={330}/>
        );
    }
    if (error) {
        return (
            <></>
        );
    }

    return (

        <div className={"row mt-5"}>
            <div className={"col-12"}>
                <div className={"row"}>
                    <div className={"col-12"}>
                        <div className={s.titleContainer}>
                            <span>Tours Across Australia</span>
                            <h2>オーストラリア全土のツアー</h2>
                        </div>
                    </div>
                </div>

                <div className={"row mt-2"}>
                    <div className={"col-12"}>
                        <LocationCard locations={locations}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LocationList;
